import React from "react";

import { documentToReactComponents, Options } from "@contentful/rich-text-react-renderer";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";
import { BLOCKS, Document as CtfDocument, Block, Inline, Text } from "@contentful/rich-text-types";

import {
  defaultRichTextOptions,
  hyperlinksOptions,
  renderTextOptions,
  transformJson,
} from "../../utils/contentful/rich-text-formatting";
import { ExpandedRichText } from "@swo/shared";

type RichTextProps = {
  richText: ExpandedRichText;
  options: "default" | "with-hyperlinks" | Options;
};

export const SORichTextRenderer: React.FC<RichTextProps> = props => {
  const richTextOptions: Options =
    props.options === "default"
      ? defaultRichTextOptions
      : props.options === "with-hyperlinks"
        ? withHyperlinks
        : props.options;

  const ctfDocument: CtfDocument = transformJson(props.richText).json as CtfDocument;

  // const plainTextLength = documentToPlainTextString(ctfDocument).length;

  return <>{documentToReactComponents(ctfDocument, richTextOptions)}</>;
};

export function calculateRichTextLength(nodes: Array<Block | Inline | Text>): number {
  // improve algo

  return nodes
    .map(node => {
      if (node.nodeType === "text") {
        return node.value;
      } else {
        return node.content.map(d => (d.nodeType === "text" ? d.value : "")).join("");
      }
    })
    .join("").length;
}

const withHyperlinks = {
  ...hyperlinksOptions,
  renderText: renderTextOptions,
};
